import React from 'react';
import { cn } from 'lib/utils';
import { Button, Icon } from 'components/ui';

interface AccountActionsProps {
  onDeleteAccount?: () => void;
  onSignOut?: () => void;
  className?: string;
}

const AccountActions: React.FC<AccountActionsProps> = ({
  onDeleteAccount,
  onSignOut,
  className
}) => {
  return (
    <div className={cn('space-y-2  flex flex-col ', className)}>
      <div>
        <h3 className="text-black font-medium text-lg mb-2">
          Account Actions
        </h3>
      </div>

      <div className="flex flex-col">
        <Button
          className='flex gap-2 justify-start hover:text-black' size='sm' onClick={onSignOut}
          variant='ghost'>
          <Icon type='signout' className='w-4' />
          Sign out
        </Button>
        <Button
          size='sm'
          className='flex gap-2 justify-start hover:text-black'
          onClick={onSignOut} variant='ghost'>
          <Icon type='trash' className='w-4' />
          Delete account
        </Button>

      </div>
    </div>
  );
};

export default AccountActions;